<div class="security-auth-list">

  <ng-template #search>
    <div *ngIf="showSearchBox" class="security-auth-list__search-box bz-border-radius--m bz-space--stack-m bz-space--inline-s">
      <bzg-input [placeholder]="('AUTHENTICATION.SEARCH_BY_OPTION_NAME' | translate)+'...'" class="security-auth-list__search-box__text" name="search-box"
          [(ngModel)]="searchValue" actionIcnPosition="right">
          <bzg-icon nameIcon="icon-search"></bzg-icon>
      </bzg-input>
    </div>
  </ng-template>

  <div *ngIf="(selectedMethod.type != 'Mixed')" class="security-auth-list__list bmc-scroll" id="list-panel">
    <h5 *ngIf="showTitle" class="security-auth-list__list__title bz-font-weight--semibold">
      {{ 'AUTHENTICATION.TYPE_' + selectedMethod.type | translate }}
    </h5>
    <ng-container *ngTemplateOutlet="search"></ng-container>
    <ul class="security-auth-list__list__items">
      <li
      *ngFor ="let item of items | searchBy : searchValue : ['translation']"
      (click)="item.key ? setSelectOption(item) : setSelectOAuthOption(item)"
      class="security-auth-list__list__item"
      [ngClass]="{'bz-color-bg--theme-100': setStyles(item)}"
      [attr.data-tooltip]="item.translation">
        <div class="security-auth-list__list__item__icon">
          <svg class="bz-icon-svg bz-icon-svg--16">
            <use href="#icon-user-authentication"></use>
          </svg>
        </div>
        <label class="security-auth-list__list__item__label">{{item.translation}}</label>
      </li>
    </ul>
  </div>

  <div *ngIf="(selectedMethod.type == 'Mixed')" class="security-auth-list__list bmc-scroll" id="list-panel">
    <bzg-tab-set (onSelectTab)="selectedTab = $event.index">
      <bzg-tab-item *ngFor="let importMethod of selectedMethod.importMethods"
        [ngClass]="{'active-tab': importMethod === selectedMixedMethod.type}"
        [active]="importMethod === selectedMixedMethod.type"
        displayName="{{ 'AUTHENTICATION.TYPE_' + importMethod | translate }}" (click)="mixedOption(importMethod)">
        <ng-container *ngTemplateOutlet="search"></ng-container>
        <ul class="security-auth-list__list__items">
          <li *ngFor="let item of selectedMixedMethod.options | keyvalue | orderByTranslate : 'AUTHENTICATION.OPTIONS_' | searchBy : searchValue : ['translation']"
            class="security-auth-list__list__item"
            [ngClass]="{'bz-color-bg--theme-100': setStyles(item)}" (click)="setSelectOption(item)"
            [attr.data-tooltip]="item.translation">
            <div class="security-auth-list__list__item__icon">
              <svg class="bz-icon-svg bz-icon-svg--16">
                <use href="#icon-user-authentication"></use>
              </svg>
            </div>
            <label class="security-auth-list__list__item__label">{{item.translation}}</label>
          </li>
        </ul>
      </bzg-tab-item>
    </bzg-tab-set>
  </div>
</div>
